module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.maintenance || _vm.invalidForm) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "page-lock"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-body"
  }, [(_vm.maintenance) ? _c('div', {
    staticClass: "lock-head"
  }, [_vm._v("System Maintenance")]) : _vm._e(), _vm._v(" "), (_vm.invalidForm) ? _c('div', {
    staticClass: "lock-head"
  }, [_vm._v("\n        Ooops! What happened to this page?\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lock-body maintenance-body"
  }, [_c('div', {
    staticClass: "lock-cont"
  }, [_c('div', {
    staticClass: "lock-item lock-item-full"
  }, [_c('p', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.maintenanceMessage)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer-custom"
  }, [_vm._v("\n      © " + _vm._s(_vm.getCurrentYear) + " CaseMGR Solutions, Inc. All Rights Reserved.\n    ")])])]) : _c('div', [_c('div', {
    staticClass: "page-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [(_vm.sent) ? _c('div', {
    staticClass: "sent-message"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.sentMessage)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn default create-new-button",
    attrs: {
      "href": _vm.downloadUrl
    }
  }, [_vm._v("Download Submission")])]) : [(_vm.loading) ? _c('vue-spinner') : _c('div', [_c('vue-form-render', {
    ref: "formRender",
    attrs: {
      "schema": _vm.currentForm.schema,
      "conditions": _vm.currentForm.conditions,
      "hideValues": _vm.currentForm.hideValues,
      "calculations": _vm.currentForm.calculations,
      "validation-conditions": _vm.currentForm.extra_validation_rules,
      "values": _vm.currentForm.values,
      "date-format": 'MM/DD/YYYY',
      "user-access-level": 1,
      "name": 'shared-form',
      "is-participant-submission": true,
      "formblock": _vm.lockFields,
      "form-previews": _vm.currentForm.form_previews
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmSubmission.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Submit\n                  ")])], 1)]], 2)])])])])]), _vm._v(" "), _c('page-footer'), _vm._v(" "), (_vm.showSubmissionConfirmModal) ? _c('shared-form-confirm-modal', {
    on: {
      "display": function($event) {
        _vm.showSubmissionConfirmModal = $event
      },
      "confirm": _vm.onSubmit
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logo"
  }, [_c('a', {
    staticClass: "brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/pages/img/logo.png",
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_c('div', {
    staticClass: "page-logo",
    staticStyle: {
      "width": "133px"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-default",
    attrs: {
      "src": "/static/layouts/layout2/img/logo-default.png",
      "alt": "logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "page-top"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637badc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ParticipantSharedForm.vue
// module id = 1668
// module chunks = 1